import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "sales-report-new-kpis" };
const _hoisted_2 = { class: "attributed_revenue block__content" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { class: "title" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1);
const _hoisted_6 = { class: "value" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", { class: "prefix" }, "R$", -1);
const _hoisted_8 = { class: "sales" };
const _hoisted_9 = { class: "sales-report-new-kpis__second-block-wrapper" };
const _hoisted_10 = { class: "contacts-made block__content" };
const _hoisted_11 = { key: 0 };
const _hoisted_12 = { class: "title" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1);
const _hoisted_14 = { class: "value default" };
const _hoisted_15 = { class: "revenue-by-contact block__content" };
const _hoisted_16 = { key: 0 };
const _hoisted_17 = { class: "title" };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1);
const _hoisted_19 = { class: "value default" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("span", { class: "prefix" }, "R$", -1);
const _hoisted_21 = { class: "conversion-rate block__content" };
const _hoisted_22 = { key: 0 };
const _hoisted_23 = { class: "title" };
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1);
const _hoisted_25 = { class: "value default" };
const _hoisted_26 = { class: "avarege-ticket block__content" };
const _hoisted_27 = { key: 0 };
const _hoisted_28 = { class: "title" };
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1);
const _hoisted_30 = { class: "value default" };
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("span", { class: "prefix" }, "R$", -1);
const _hoisted_32 = { class: "window-conversion block__content" };
const _hoisted_33 = { key: 0 };
const _hoisted_34 = { class: "title" };
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1);
const _hoisted_36 = { class: "value default" };
const _hoisted_37 = { class: "days" };
import { onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import i18n from '@/i18n';
// components
import BaseLoader from '@/components/_atoms/BaseLoaderSpinner.vue';
import InfoCard from '@/components/_atoms/InfoCard.vue';
// utils
import { formatCurrency, formatDecimal, formatPercent } from '@/utilities/formatters';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SalesReportNewKpis',
    setup(__props) {
        // libs
        const store = useStore();
        // actions
        const fetchIndicators = () => store.dispatch('salesReportNew/setFetchIndicators');
        // computed
        const kpis = computed(() => store.getters['salesReportNew/getKpis']);
        const isLoading = computed(() => store.getters['salesReportNew/getIsIndicatorsLoading']);
        const hasError = computed(() => store.getters['salesReportNew/getHasIndicatorsError']);
        const replacePeriodsWithCommas = (value) => value?.replace('.', ',');
        const formatTotalSales = (value) => {
            return `${formatDecimal(value)} ${i18n.global.tc('_sale', value).toLowerCase()}`;
        };
        onMounted(() => {
            fetchIndicators();
        });
        return (_ctx, _cache) => {
            const _component_el_popover = _resolveComponent("el-popover");
            const _component_base_card_v2 = _resolveComponent("base-card-v2");
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createVNode(_component_base_card_v2, { class: "sales-report-new-kpis__first-block" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            (!isLoading.value && !hasError.value && kpis.value?.revenue)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                    _createVNode(_component_el_popover, {
                                        trigger: "hover",
                                        placement: "top",
                                        width: 200
                                    }, {
                                        reference: _withCtx(() => [
                                            _createElementVNode("p", _hoisted_4, [
                                                _createTextVNode(_toDisplayString(kpis.value?.revenue?.name) + " ", 1),
                                                _hoisted_5
                                            ])
                                        ]),
                                        default: _withCtx(() => [
                                            _createElementVNode("p", null, _toDisplayString(kpis.value?.revenue?.tooltip), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createElementVNode("div", _hoisted_6, [
                                        _hoisted_7,
                                        _createElementVNode("span", null, _toDisplayString(_unref(formatCurrency)(kpis.value?.revenue?.value, { noSymbol: true })), 1)
                                    ]),
                                    _createElementVNode("div", null, [
                                        _createElementVNode("p", _hoisted_8, _toDisplayString(formatTotalSales(kpis.value?.revenue?.totalSales)), 1)
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (isLoading.value)
                                ? (_openBlock(), _createBlock(BaseLoader, { key: 1 }))
                                : _createCommentVNode("", true),
                            (hasError.value && !isLoading.value)
                                ? (_openBlock(), _createBlock(InfoCard, {
                                    key: 2,
                                    ref: "message-error",
                                    error: hasError.value
                                }, null, 8, ["error"]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _: 1
                }),
                _createVNode(_component_base_card_v2, { class: "sales-report-new-kpis__second-block" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                (!isLoading.value && !hasError.value && kpis.value?.realized)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _createVNode(_component_el_popover, {
                                            trigger: "hover",
                                            placement: "top",
                                            width: 180
                                        }, {
                                            reference: _withCtx(() => [
                                                _createElementVNode("p", _hoisted_12, [
                                                    _createTextVNode(_toDisplayString(kpis.value?.realized?.name) + " ", 1),
                                                    _hoisted_13
                                                ])
                                            ]),
                                            default: _withCtx(() => [
                                                _createElementVNode("p", null, _toDisplayString(kpis.value?.realized?.tooltip), 1)
                                            ]),
                                            _: 1
                                        }),
                                        _createElementVNode("div", _hoisted_14, [
                                            _createElementVNode("span", null, _toDisplayString(_unref(formatDecimal)(kpis.value?.realized?.value)), 1)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (isLoading.value)
                                    ? (_openBlock(), _createBlock(BaseLoader, { key: 1 }))
                                    : _createCommentVNode("", true),
                                (hasError.value && !isLoading.value)
                                    ? (_openBlock(), _createBlock(InfoCard, {
                                        key: 2,
                                        ref: "message-error",
                                        error: hasError.value
                                    }, null, 8, ["error"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                                (!isLoading.value && !hasError.value && kpis.value?.revenuePerContact)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        _createVNode(_component_el_popover, {
                                            trigger: "hover",
                                            placement: "top",
                                            width: 165
                                        }, {
                                            reference: _withCtx(() => [
                                                _createElementVNode("p", _hoisted_17, [
                                                    _createTextVNode(_toDisplayString(kpis.value?.revenuePerContact?.name) + " ", 1),
                                                    _hoisted_18
                                                ])
                                            ]),
                                            default: _withCtx(() => [
                                                _createElementVNode("p", null, _toDisplayString(kpis.value?.revenuePerContact?.tooltip), 1)
                                            ]),
                                            _: 1
                                        }),
                                        _createElementVNode("div", _hoisted_19, [
                                            _hoisted_20,
                                            _createElementVNode("span", null, _toDisplayString(_unref(formatCurrency)(kpis.value?.revenuePerContact?.value, { noSymbol: true })), 1)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (isLoading.value)
                                    ? (_openBlock(), _createBlock(BaseLoader, { key: 1 }))
                                    : _createCommentVNode("", true),
                                (hasError.value && !isLoading.value)
                                    ? (_openBlock(), _createBlock(InfoCard, {
                                        key: 2,
                                        ref: "message-error",
                                        error: hasError.value
                                    }, null, 8, ["error"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                                (!isLoading.value && !hasError.value && kpis.value?.convertionRate)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                        _createVNode(_component_el_popover, {
                                            trigger: "hover",
                                            placement: "top",
                                            width: 190
                                        }, {
                                            reference: _withCtx(() => [
                                                _createElementVNode("p", _hoisted_23, [
                                                    _createTextVNode(_toDisplayString(kpis.value?.convertionRate?.name) + " ", 1),
                                                    _hoisted_24
                                                ])
                                            ]),
                                            default: _withCtx(() => [
                                                _createElementVNode("p", null, _toDisplayString(kpis.value?.convertionRate?.tooltip), 1)
                                            ]),
                                            _: 1
                                        }),
                                        _createElementVNode("div", _hoisted_25, [
                                            _createElementVNode("span", null, _toDisplayString(_unref(formatPercent)(parseFloat(kpis.value?.convertionRate?.value) / 100, 2)), 1)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (isLoading.value)
                                    ? (_openBlock(), _createBlock(BaseLoader, { key: 1 }))
                                    : _createCommentVNode("", true),
                                (hasError.value && !isLoading.value)
                                    ? (_openBlock(), _createBlock(InfoCard, {
                                        key: 2,
                                        ref: "message-error",
                                        error: hasError.value
                                    }, null, 8, ["error"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                                (!isLoading.value && !hasError.value && kpis.value?.aov)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                        _createVNode(_component_el_popover, {
                                            trigger: "hover",
                                            placement: "top",
                                            width: 190
                                        }, {
                                            reference: _withCtx(() => [
                                                _createElementVNode("p", _hoisted_28, [
                                                    _createTextVNode(_toDisplayString(kpis.value?.aov?.name) + " ", 1),
                                                    _hoisted_29
                                                ])
                                            ]),
                                            default: _withCtx(() => [
                                                _createElementVNode("p", null, _toDisplayString(kpis.value?.aov?.tooltip), 1)
                                            ]),
                                            _: 1
                                        }),
                                        _createElementVNode("div", _hoisted_30, [
                                            _hoisted_31,
                                            _createElementVNode("span", null, _toDisplayString(_unref(formatCurrency)(kpis.value?.aov?.value, { noSymbol: true })), 1)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (isLoading.value)
                                    ? (_openBlock(), _createBlock(BaseLoader, { key: 1 }))
                                    : _createCommentVNode("", true),
                                (hasError.value && !isLoading.value)
                                    ? (_openBlock(), _createBlock(InfoCard, {
                                        key: 2,
                                        ref: "message-error",
                                        error: hasError.value
                                    }, null, 8, ["error"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                                (!isLoading.value && !hasError.value && kpis.value?.averageWindow)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                        _createVNode(_component_el_popover, {
                                            trigger: "hover",
                                            placement: "top",
                                            width: 190
                                        }, {
                                            reference: _withCtx(() => [
                                                _createElementVNode("p", _hoisted_34, [
                                                    _createTextVNode(_toDisplayString(kpis.value?.averageWindow?.name) + " ", 1),
                                                    _hoisted_35
                                                ])
                                            ]),
                                            default: _withCtx(() => [
                                                _createElementVNode("p", null, _toDisplayString(kpis.value?.averageWindow?.tooltip), 1)
                                            ]),
                                            _: 1
                                        }),
                                        _createElementVNode("div", _hoisted_36, [
                                            _createElementVNode("span", null, [
                                                _createTextVNode(_toDisplayString(_unref(formatDecimal)(replacePeriodsWithCommas(String(kpis.value?.averageWindow?.value)), 2)) + " ", 1),
                                                _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$tc('day', parseInt(kpis.value?.averageWindow?.value))), 1)
                                            ])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (isLoading.value)
                                    ? (_openBlock(), _createBlock(BaseLoader, { key: 1 }))
                                    : _createCommentVNode("", true),
                                (hasError.value && !isLoading.value)
                                    ? (_openBlock(), _createBlock(InfoCard, {
                                        key: 2,
                                        ref: "message-error",
                                        error: hasError.value
                                    }, null, 8, ["error"]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
